import * as React from 'react'
import { isRtl } from '../../../i18nInit'
import { t } from 'ttag'
import YumButton from '../../YumButton/YumButton'
import { CustomType, GoalWithProgress } from '../../../services/api.types'
import { IJoinGoalPayload } from '../../../views/Activity/store/ActivitySagas'
import dayjs from '../../../dayjsConfig'
import { convertUTCToLocalDate } from '../../../common/helpers/date'

export interface IYumGoalRankingJoinButtonProps {
  goal: GoalWithProgress
  joinInProgress: boolean
  isLegacyRanking: boolean
  addMargin?: boolean
  // When true, prefer a right margin in LTR.
  // This keeps spacing consistent in compact header layouts.
  marginRight?: boolean
}

export interface IYumGoalRankingJoinButtonDispatchProps {
  joinGoal(payload: IJoinGoalPayload): void
}

export const YumGoalRankingJoinButton = (
  props: IYumGoalRankingJoinButtonProps & IYumGoalRankingJoinButtonDispatchProps,
) => {
  const { goal, joinInProgress, isLegacyRanking, addMargin, marginRight, joinGoal } = props

  const onJoinGoal = () => {
    const isPoints = goal.customType === CustomType.POINTS
    const pointsLogic = isPoints ? JSON.parse(goal.pointsLogic) : null
    const challengeStartDate = dayjs(convertUTCToLocalDate(new Date(goal.startDate)))
    const challengeEndDate = dayjs(convertUTCToLocalDate(new Date(goal.endDate)))

    joinGoal({
      goalId: goal.id,
      progressType: goal.progressType,
      customType: goal.customType,
      manualEntryEnabled: goal.manualEntryEnabled,

      // For refreshChallengeResults.
      isPoints,
      pointsLogic,
      startDateFormatted: challengeStartDate.locale('en').format('YYYY-MM-DD'),
      endDateFormatted: challengeEndDate.locale('en').format('YYYY-MM-DD'),

      isLegacyRanking,
    })
  }

  return (
    <YumButton
      size="small"
      color="secondary"
      // We keep spacing optional and explicit to avoid layout surprises.
      // marginRight flips for RTL so spacing stays visually correct.
      style={
        !addMargin
          ? {}
          : marginRight
            ? isRtl
              ? { marginLeft: '8px' }
              : { marginRight: '8px' }
            : isRtl
              ? { marginRight: '8px' }
              : { marginLeft: '8px' }
      }
      onClick={onJoinGoal}
      disabled={joinInProgress}
    >
      {t`Join`}
    </YumButton>
  )
}
